// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1GXV_","productName":"Table_productName__1PQXk"};